export enum ThresholdTypeEnums {
  EDIT_DISTANCE = 'edit-distance',
  SIMILARITY = 'similarity',
}
